import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { System } from '../System';
import { Staff, StaffSearchCriteria } from './staff.model';
import { Observable } from 'rxjs';

@Injectable()
export class StaffSearchService {

    // Properties
    unsavedQueryApplied: boolean;
    staffSearchCriteria = new StaffSearchCriteria()

    // Class Functions
    constructor(
        private http: HttpClient
    ) { }

    // Service Methods
    getStaffSearch(schoolId: number, yearId: number, activeToday: boolean, employeeNumber: string, firstName: string, lastName: string, schoolIds: number[],
                   Teacher: string, Substitute: string, Advisor: string, Counselor: string, Nurse: string, Disciplinarian: string,
                   Administrator: string, Superintendent: string, Principal: string, Other: string, SpecialEdTeacher: string,
                   SpecialEdServiceProvider: string, SpecialEdCaseManager: string, ActiveStaff: boolean, Status = 'All',
                   PermissionGroupId = 0, Username = '', ShowAllSchool = false, ShowAllPermissionGroups = false
    ): Observable<Staff[]> {
        const queryString = '?schoolId=' + schoolId +
            '&yearId=' + yearId +
            '&activeToday=' + activeToday +
            '&employeeNumber=' + employeeNumber +
            '&firstName=' + firstName +
            '&lastName=' + lastName +
            '&Teacher=' + Teacher +
            '&Substitute=' + Substitute +
            '&Advisor=' + Advisor +
            '&Counselor=' + Counselor +
            '&Nurse=' + Nurse +
            '&Disciplinarian=' + Disciplinarian +
            '&Administrator=' + Administrator +
            '&Superintendent=' + Superintendent +
            '&Principal=' + Principal +
            '&Other=' + Other +
            '&SpecialEdTeacher=' + SpecialEdTeacher +
            '&SpecialEdServiceProvider=' + SpecialEdServiceProvider +
            '&SpecialEdCaseManager=' + SpecialEdCaseManager +
            '&ActiveStaff=' + ActiveStaff +
            '&Status=' + Status +
            '&PermissionGroupId=' + PermissionGroupId +
            '&Username=' + Username +
            '&ShowAllSchool=' + ShowAllSchool +
            '&ShowAllPermissionGroups=' + ShowAllPermissionGroups;
        return this.http.post<Staff[]>(System.apiURL.Student + 'GetStaff' + queryString, schoolIds);
    }

    getStaffByStaffIds(staffIds: number[]): Observable<Staff[]> {
        return this.http.post<Staff[]>(System.apiURL.Student + 'GetStaffByStaffIds', staffIds);
    }
}